module.exports = __webpack_public_path__ + "img/wtsp.50e2f84f.svg";